module.exports = __webpack_public_path__ + "static/media/apple-podcasts.ea8698f3.png";